import { Category } from '@modules/common/types';
import { getCategoryColor } from '@modules/common/utils';
import { Box, Chip, ChipProps, Stack, Typography } from '@mui/material';

interface LabelChipProps extends ChipProps {
  displayName: string;
  category?: Category;
  renderLabelIcon?: () => React.ReactNode;
  isSelected?: boolean;
}

export const LabelChip = ({
  displayName,
  category,
  renderLabelIcon,
  isSelected = false,
  size = 'small',
  variant = 'outlined',
  sx = {},
  ...chipProps
}: LabelChipProps) => {
  const getChipBorderColor = () => {
    if (isSelected && category) {
      return getCategoryColor(category);
    }
  };

  return (
    <Chip
      size={size}
      label={
        chipProps.disabled ? (
          <Box component="s">{displayName}</Box>
        ) : (
          <Stack direction="row" spacing={0.5} alignItems="center">
            {renderLabelIcon?.()}
            <Typography whiteSpace="normal" variant="caption">
              {displayName}
            </Typography>
          </Stack>
        )
      }
      variant={variant}
      {...chipProps}
      sx={{
        borderColor: getChipBorderColor(),
        height: '100%',
        ...sx,
      }}
    />
  );
};
